module.exports = __webpack_public_path__ + "img/island-active.72180b27.png";